import { createSlice, createSelector } from '@reduxjs/toolkit';
import { logout } from "../common/reducers/initContext";
import { dataHookFactory, initMapFactory } from '../common/reducers/utilities';
import { ensureArray } from '../common/utils/arrayUtilities';

const compareUpdates = (n1, n2) => n1.id === n2.id;

const jobUpdateSlice = createSlice({
    name: 'jobUpdate',
    initialState: {
        data: {}
    },
    reducers: {
        set: (state, action) => {
            ensureArray(action.payload).forEach(dt => {
                delete state.data[dt.jobid?.toString()];
            });
            ensureArray(action.payload).forEach(dt => {
                const jobid = dt.jobid?.toString();
                if (!state.data[jobid]) {
                    state.data[jobid] = []
                }
                state.data[jobid].push(dt);
            });
        },
        addOrUpdate: (state, action) => {
            for (const dt of ensureArray(action.payload)) {
                const jobid = dt.jobid?.toString();
                if (state.data[jobid]) {
                    let idx = state.data[jobid].findIndex(a => compareUpdates(a, dt));
                    if (idx >= 0) {
                        state.data[jobid].splice(idx, 1, dt);
                    } else {
                        state.data[jobid].push(dt);
                    }
                } else {
                    state.data[jobid] = [dt];
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => jobUpdateSlice.getInitialState());
    }
});

// #region network operations
const fetchJobUpdates = jobid => network => network.get('/api/v1/jobUpdates/' + encodeURIComponent(jobid), jobUpdateSlice.actions.set);
export const createJobUpdate = (network, update) => network.put('/api/v1/jobUpdate', update, jobUpdateSlice.actions.addOrUpdate);
// #endregion

// #region selectors
const selectUpdates = state => state.jobUpdate.data;

// we now make a reselect to memoize a select function parameterized by jobid and expose that factory through a convenience function
const selectUpdatesByJobID = createSelector([selectUpdates, (note, jobid) => jobid], (note, jobid) => {
    return note[jobid?.toString()] ?? []
});
const selectJobUpdates = jobid => state => selectUpdatesByJobID(state, jobid);
// #endregion

// #region listeners
const listen = {
    jobUpdateCreated: (update, { dispatch }) => dispatch(jobUpdateSlice.actions.addOrUpdate(update))
}
// #endregion

export const [useJobUpdates] = dataHookFactory(selectJobUpdates, initMapFactory(fetchJobUpdates, listen));

const reducerDetails = { name: jobUpdateSlice.name, reducer: jobUpdateSlice.reducer };
export default reducerDetails;